import http from "./http";
import axios from "axios";
import { Loading } from "element-ui";
import config from "../common/config";

/* 获取组织列表（多租户）
** 参数: userCode 非空 
*/
const getUserOneLevelDeptService = (userCode) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/organize/getUserOneLevelDept', { userCode: userCode }, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 通过用户，获取公司列表
/* 获取海信子公司列表
** 参数: deptCode 可空 传入公司deptCode,可根据公司查询分管小区列表
*/
const getDepartmentListService = (userCode = sessionStorage.getItem("userCode")) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/userStationManage/getDeptList', { userCode: userCode }, true).then(result => {
            result.resultCode == '0' ? resolve(result.data) : reject(result.msg);
        }).catch(error => {
            reject(error);
        })
    });
}


/* 获取公司列表
** 参数: page 页码
** 参数: rows 分页数量
*/
const getDeptListService = (userCode = sessionStorage.getItem("userCode"), page = 1, rows = 999) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/userStationManage/getDeptList', { userCode: userCode, page: page, rows: rows }, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 通过分公司，获取小区列表
** 参数: deptCode 可空 传入公司deptCode,可根据公司查询分管小区列表
*/
const getAreaListByDeptCodeService = (deptCode) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-property-house/house/area/getListAreasByDeptCode', { deptCode: deptCode }, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 通过用户、分页、名称搜索小区
** 参数: deptCode 可空 传入公司deptCode,可根据公司查询分管小区列表
** 参数: userCode 可空 
*/
const getAreaInfoByPageService = (deptCode, userCode, areaName, page, rows) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-property-house/house/area/getAreaInfoByPage', { deptCode: deptCode, userCode: userCode, areaName: areaName, page: page, rows: rows }, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 通过用户、公司，获取小区列表
** 参数: userCode 非空 userCode,可根据用户查询授权小区列表
** 参数: deptCode 可空 deptCode,可根据公司查询下属小区列表
*/
const getAreaListByUserCodeService = (userCode, deptCode) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-property-house/house/area/getAreaCodeByUser', { userCode: userCode, deptCode: deptCode }, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 通过小区，获取楼栋列表
** 参数: areaCode 非空 areaCode,可根据小区查询楼栋列表
*/
const getBuildInfoByAreaCodeService = (areaCode) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-property-house/house/build/getBuildInfoByAreaCode', { areaCode: areaCode }, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 通过楼栋，获取房间列表
** 参数: areaCode 非空 areaCode,可根据小区查询楼栋列表
*/
const getRoomsByBuildCodeService = (buildCode) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-property-house/house/getRoomsByBuildCode', { buildCode: buildCode }, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 获取用户授权的按钮列表，通过左侧菜单进入的每个页面均要调用
** 参数: menuCode 非空 左侧菜单的ID
*/
const getRoleMenuBtnService = (menuCode) => {
    return new Promise((resolve, reject) => {
        let reqParm = { 
            menuCode: menuCode, 
            userCode: sessionStorage.getItem('userCode'), 
            roleCode: sessionStorage.getItem('roleCode') 
        };
        http.get('/xwj-sys-user/userRoleManage/getRoleMenuBtn', reqParm, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/*
** 导出Excel表格请求
** 参数： url：   导出excel表格所请求的url
**       param： 导出接口对应的请求参数
** 以缴费房间对应请求参数为例
**     url   : '/xwj-property-payment/paymentRoomEnquiry/getRoomExcel'
**     param : { data: JSON.stringify({"USER_ID": this.userCode, "PAGE_NAME":"缴费房间信息.zip"})}
*/
const exportExcelService = (url, param, needTrim = true) => {
    return new Promise((resolve, reject) => {
        let exportUrl = `${config.baseUrl}${url}?`;
        for (let key in param) {
            if (param[key]) {
                exportUrl += `${/\?$/.test(exportUrl) ? '' : '&'}${key}=${encodeURI(param[key])}`;
                console.log(exportUrl)
            }
        }
        try {
            var elemIF = document.createElement("iframe");
            elemIF.src = needTrim ? exportUrl.replace(/\s*/g, "") : exportUrl;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
            let self = this;
            elemIF.onload = function () {
                reject()
            };
        } catch (e) {
            console.error(e);
        }
    })
}


const exportExcelWithCallBack = (url, param,fileName) => {
    let loading = Loading.service({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.5)"
      });
    return new Promise((resolve, reject) => {
        console.log(process.env.VUE_APP_BASEURL);
        axios({
            // 用axios发送post请求
            method: 'get',
            withCredentials: true,
            url: `${process.env.NODE_ENV === 'development' ? '/api' : config.baseUrl}${url}?`, // 请求地址
            params: param,
            responseType: 'blob',//防止导出文件破损或乱码

        }).then(res => {
            try {
                if (res) {
                    var blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8" });
                    var filename = fileName;
                    var a = document.createElement('a');
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename;
                    var body = document.getElementsByTagName('body')[0];
                    body.appendChild(a);
                    a.click();
                    body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                    loading.close();
                    resolve()
                }

            } catch (e) {
                loading.close();
                reject(e)
            }
        }).catch(error => {
            loading.close();
            reject(error)
        })
    })
}

//获取临时下载地址 新接口 20230921
const getTempUrlService = param => {
    return new Promise((resolve, reject) => {
        http
            .post("/common-web/oss/getTempUrlAndRenameOpt", param)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//获取预览地址 新接口 20230921
const getPreviewUrlService = param => {
    return new Promise((resolve, reject) => {
        http
            .post("/common-web/oss/getPreviewUrl", param,true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};
/*
 ** 导出Excel表格请求
 ** 参数： url：   导出excel表格所请求的url
 **       param： 导出接口对应的请求参数
 ** 以缴费房间对应请求参数为例
 **     url   : '/xwj-property-payment/paymentRoomEnquiry/getRoomExcel'
 **     param : { data: JSON.stringify({"USER_ID": this.userCode, "PAGE_NAME":"缴费房间信息.zip"})}
 */
 const exportExcelService2 = (url, param, needTrim = true) => {
    let baseUrl = config.baseUrl + "/contract-web";
    return new Promise((resolve, reject) => {
        //let exportUrl = `${baseUrl}${url}?`;
        let exportUrl = url;
        // for (let key in param) {
        //     if (param[key]) {
        //         exportUrl += `${/\?$/.test(exportUrl) ? '' : '&'}${key}=${encodeURI(param[key])}`;
        //         console.log(exportUrl)
        //     }
        // }
        try {
            const downloadUrl = needTrim ? exportUrl.replace(/\s*/g, "") : exportUrl           
                var elemIF = document.createElement("iframe");
                elemIF.src = downloadUrl
                elemIF.style.display = "none";
                document.body.appendChild(elemIF);
                let self = this;
                elemIF.onload = function () {
                    reject();
                };            
        } catch (e) {
            console.error(e);
        }
    });
};

export {
    getUserOneLevelDeptService,
    getDepartmentListService, getDeptListService, getAreaListByDeptCodeService, getAreaInfoByPageService,
    getAreaListByUserCodeService, getBuildInfoByAreaCodeService, getRoomsByBuildCodeService, getRoleMenuBtnService, exportExcelService,
    exportExcelWithCallBack,
    getTempUrlService,
    getPreviewUrlService,
    exportExcelService2, //导出
}